"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalView = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Modal_1 = require("../ui/Modal");
var React = __importStar(require("react"));
var UiAction_1 = require("../uiAction/UiAction");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("../ui/Button");
var IconSymbols_1 = require("../generated/IconSymbols");
var ModalView = /** @class */ (function (_super) {
    __extends(ModalView, _super);
    function ModalView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalView.prototype.render = function () {
        var _a;
        var model = this.props.model;
        return (0, jsx_runtime_1.jsxs)(Modal_1.Modal, __assign({}, model.componentProps, { wrapperAnimationClassName: model.animationClass, onClose: model.onClose }, { children: [model.title || model.showClose ?
                    (0, jsx_runtime_1.jsxs)(Modal_1.ModalHeader, { children: [model.title, model.showClose ?
                                (0, jsx_runtime_1.jsx)(Button_1.ButtonIcon, { className: "modal__close", onClick: model.onClose, type: Button_1.ButtonTypes.OUTLINE_PRIMARY, shape: Button_1.ButtonIconShapes.RECTANGLE, symbol: IconSymbols_1.IconSymbols.Close })
                                : null] })
                    : null, model.content ?
                    (0, jsx_runtime_1.jsx)(Modal_1.ModalContent, { children: model.content })
                    : null, ((_a = model.actions) === null || _a === void 0 ? void 0 : _a.length) ?
                    (0, jsx_runtime_1.jsx)(Modal_1.ModalFooter, __assign({ className: "".concat(model.className || '', " py-3 container-fluid") }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "row" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "col" }, { children: model.actions.map(function (action) { return (0, jsx_runtime_1.jsx)(UiAction_1.UiActionComponent, { action: action }, action.id); }) })) })) }))
                    : null] }));
    };
    ModalView = __decorate([
        mobx_react_1.observer
    ], ModalView);
    return ModalView;
}(React.Component));
exports.ModalView = ModalView;
